import type { Event, Handler } from './types'

class EventStore {
	private handlers: Handler[] = []

	hasHandler = (name: string): boolean => this.handlers.some((handler) => handler.name === name)

	registerHandler = <E extends Event>(name: string, key: E['key'], handler: (data: E['data']) => void | Promise<void>) => {
		this.handlers.push({
			name,
			key,
			func: handler,
		})
		console.info(`Registered handler ${name} on ${key} events`)
	}

	emitEvent = async (event: Event) => {
		console.info(`Emitting event ${event.key}`)

		this.handlers.forEach(async (handler) => {
			if (handler.key === event.key) {
				try {
					await handler.func(event.data)
				} catch (err) {
					console.error(`Handler ${handler.name} failed to handle event ${event.key}`)
				}
			}
		})
	}
}

export default EventStore
